import { TopicViewModel } from '../../model/topic/types';

export const LOADING_TRENDING_TOPICS = 'LOADING_TRENDING_TOPICS';
export const LOADED_TRENDING_TOPICS = 'LOADED_TRENDING_TOPICS';
export const SAVED_TRENDING_TOPIC = 'SAVED_TRENDING_TOPIC';

export interface LoadingTendingTopicsAction {
  type: typeof LOADING_TRENDING_TOPICS;
}

export interface LoadedTrendingTopicsAction {
  type: typeof LOADED_TRENDING_TOPICS;
  payload: TopicViewModel[];
}

export interface SavedTrendingTopic {
  type: typeof SAVED_TRENDING_TOPIC;
  payload: TopicViewModel;
}

export type ContentActionTypes =
  | LoadingTendingTopicsAction
  | LoadedTrendingTopicsAction
  | SavedTrendingTopic;

export enum ContentDisplayLoadingStatus {
  Uninitialized,
  Loading,
  Loaded,
  Error
}

export interface ContentDisplayState {
  status: ContentDisplayLoadingStatus;
  trendingTopics: TopicViewModel[];
}
